// Recovered compiled webpack factory 77370. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "createRenderParamsFromClient", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(23982),
    a = new WeakMap();
  function o(e) {
    let t = a.get(e);
    if (t) return t;
    let r = Promise.resolve(e);
    return (
      a.set(e, r),
      Object.keys(e).forEach((t) => {
        n.wellKnownProperties.has(t) || (r[t] = e[t]);
      }),
      r
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
